// import {CustomCssVarsFn} from '@wix/yoshi-flow-editor'

import {
  StylesParamsType,
  // convertAlignmentNumberToString,
} from '../../types/createStylesParams'

import {layoutStylesParams, LayoutStylesParams} from './Settings/Tabs/Layout/stylesParams'
import {textStylesParams, TextStylesParams} from './Settings/Tabs/Design/Text/stylesParams'
import {
  locationTabsStylesParams,
  LocationTabsStylesParams,
} from './Settings/Tabs/Design/LocationTabs/stylesParams'
import {imageStylesParams, ImageStylesParams} from './Settings/Tabs/Design/Image/stylesParams'
import {buttonStylesParams, ButtonStylesParams} from './Settings/Tabs/Design/Button/stylesParams'
import {
  backgroundAndBordersStylesParams,
  BackgroundAndBordersStylesParams,
} from './Settings/Tabs/Design/BackgroundAndBorders/stylesParams'

export type StylesParams = LayoutStylesParams &
  TextStylesParams &
  LocationTabsStylesParams &
  ImageStylesParams &
  ButtonStylesParams &
  BackgroundAndBordersStylesParams

export const stylesParams: StylesParamsType<StylesParams> = {
  ...layoutStylesParams,
  ...textStylesParams,
  ...locationTabsStylesParams,
  ...imageStylesParams,
  ...buttonStylesParams,
  ...backgroundAndBordersStylesParams,
}

export default stylesParams

/* TODO: test migration from settingsParams to styleParams */
// export const customCssVars: CustomCssVarsFn = ({styleParams}) => {
//   const numbers = styleParams.numbers
//
//   const cssVars = {
//     breadcrumbsAlignment: convertAlignmentNumberToString(numbers.breadcrumbsAlignment),
//   }
//
//   return cssVars
// }
